import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import LayerFigure from './layer-figure';
import { fetchLayerData } from '@actions/layers-actions';

const Layers = ({ list, name, next, publicMap }) => {
  const dispatch = useDispatch();

  const layers = useSelector(state => state.layers);
  const bounds = useSelector(state => state.map.viewport.bounds);

  const prevNextRef = useRef(next);

  // Initial fetch on mount
  useEffect(() => {
    if (!layers[name].list.length && bounds) {
      dispatch(fetchLayerData(name, publicMap));
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // Pagination fetch when next changes
  useEffect(() => {
    if (!layers[name].loadingComplete && next && prevNextRef.current !== next && bounds) {
      dispatch(fetchLayerData(name));
    }
    prevNextRef.current = next;
  }, [bounds, dispatch, layers, name, next]);

  return list.map(layer => <LayerFigure key={layer.id} layer={layer} name={name} />);
};

Layers.propTypes = {
  list: PropTypes.array,
  name: PropTypes.string,
  next: PropTypes.string
};

export default Layers;
